import BusinessDashboard from './BusinessDashboard';

export default BusinessDashboard;
